import { CurrencyInput, Grid } from "../../../../../components";
import { unformatPrice } from "../../../../../utils";

const NfSaidaTributos = ({ nfSaida, setNfSaida, nfSaidaEntity }) => {
  const handleInputChange = (event) => {
    nfSaidaEntity.setHandleChangeInput(
      event.target.name,
      unformatPrice(event.target.value)
    );
    setNfSaida(nfSaidaEntity);
  };

  return (
    <>
      <Grid container spacing={2} columns={15}>
        <Grid item xs={3}>
          <CurrencyInput
            id="baseIcms"
            name="baseIcms"
            label="Base ICMS"
            margin="normal"
            disabled
            value={nfSaida?.baseIcmsTotal || "0"}
            onBlur={handleInputChange}
            fullWidth
          />
        </Grid>
        <Grid item xs={3}>
          <CurrencyInput
            id="valorIcms"
            name="valorIcms"
            label="Valor ICMS"
            margin="normal"
            disabled
            value={nfSaida?.valorIcmsTotal || "0"}
            onBlur={handleInputChange}
            fullWidth
          />
        </Grid>
        <Grid item xs={3}>
          <CurrencyInput
            id="valorIpi"
            name="valorIpi"
            label="Valor IPI"
            margin="normal"
            disabled
            value={nfSaida?.valorIpiTotal || "0"}
            onBlur={handleInputChange}
            fullWidth
          />
        </Grid>
        <Grid item xs={3}>
          <CurrencyInput
            id="baseIcmsSt"
            name="baseIcmsSt"
            label="Base ICMS ST"
            margin="normal"
            disabled
            value={nfSaida?.baseIcmsSt || "0"}
            onBlur={handleInputChange}
            fullWidth
          />
        </Grid>
        <Grid item xs={3}>
          <CurrencyInput
            id="valorIcmsSt"
            name="valorIcmsSt"
            label="Valor ICMS ST"
            margin="normal"
            disabled
            value={nfSaida?.valorIcmsSt || "0"}
            onBlur={handleInputChange}
            fullWidth
          />
        </Grid>
        <Grid item xs={3}>
          <CurrencyInput
            id="valorIbsUf"
            name="valorIbsUf"
            label="Valor IBS UF"
            margin="normal"
            disabled
            value={nfSaida?.valorIbsUf || "0"}
            onBlur={handleInputChange}
            fullWidth
          />
        </Grid>
        <Grid item xs={3}>
          <CurrencyInput
            id="valorIbsMun"
            name="valorIbsMun"
            label="Valor IBS Mun."
            margin="normal"
            disabled
            value={nfSaida?.valorIbsMun || "0"}
            onBlur={handleInputChange}
            fullWidth
          />
        </Grid>
        <Grid item xs={3}>
          <CurrencyInput
            id="valorCbs"
            name="valorCbs"
            label="Valor CBS"
            margin="normal"
            disabled
            value={nfSaida?.valorCbsTotal || "0"}
            onBlur={handleInputChange}
            fullWidth
          />
        </Grid>
        <Grid item xs={3}>
          <CurrencyInput
            id="valorIs"
            name="valorIs"
            label="Valor IS"
            margin="normal"
            disabled
            value={nfSaida?.valorIs || "0"}
            onBlur={handleInputChange}
            fullWidth
          />
        </Grid>
        <Grid item xs={3}>
          <CurrencyInput
            id="valorCredPresumido"
            name="valorCredPresumido"
            label="Valor Cred. Presumido"
            margin="normal"
            disabled
            value={nfSaida?.valorCredPresumido || "0"}
            onBlur={handleInputChange}
            fullWidth
          />
        </Grid>
      </Grid>
    </>
  );
};

export default NfSaidaTributos;
